/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkPackageCategoryDto } from '../../models/work-package-category-dto';

export interface GetWorkPackageCategory$Params {
  id: string;
}

export function getWorkPackageCategory(http: HttpClient, rootUrl: string, params: GetWorkPackageCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, getWorkPackageCategory.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackageCategoryDto>;
    })
  );
}

getWorkPackageCategory.PATH = '/v0/workPackageCategories/{id}';
